import { EventBus, Event } from '@ps/utils/event-bus'
import gameIframe from '@ps/bridge/iframe/iframe'
import * as bgScript from '@ps/bridge/qc/scripts/bg-config'
import assets from '@ps/bridge/qc/assets'
import router from '@ps/router'
import { generateUUID } from '@ps/utils/game'
import { getBgImgBinUrl } from '@ps/workbench/global-config'
import { saveGlobalUrlMap } from '@ps/bridge/resource/global-url-map'

export default {
  namespaced: true,

  state: {
    bgUrl: '',
    bgmUrl: '',
  },
  getters: {
    realBgUrl(state, getters, rootState) {
      if (!rootState.workspace.game.gameReady) {
        return ''
      }
      const gamePlay = gameIframe.gamePlay
      const bgConfig = bgScript.getScript(gamePlay, false)
      if (bgConfig) {
        return bgConfig.bgUrl
      }
      return state.bgUrl
    },
  },
  mutations: {
    updateBgUrl(state, { url }) {
      state.bgUrl = url
    },
    updateBgmUrl(state, { url }) {
      state.bgmUrl = url
    },
  },

  actions: {
    // 如果file属性不是一个标准的file对象，则使用dataURL
    async updateBgImage({ state }, { file, dataURL }) {
      console.log(file)
      let fileObj = null
      if (dataURL) {
        const arr = dataURL.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        fileObj = new File([u8arr], 'pb_bg', { type: mime })
      } else {
        fileObj = file.raw
      }
      // 自研素材的uuid列表有时会没有pb_bg,替换新增背景图片时需要对uuid列表补上pb_bg
      const bgImgBin = getBgImgBinUrl()
      if (
        !Object.values(assets.uuid2UrlConf).some(
          (item) => item.indexOf(bgImgBin) > -1,
        )
      ) {
        const uuid = generateUUID()
        assets.uuid2UrlConf = {
          ...assets.uuid2UrlConf,
          [uuid]: bgImgBin,
        }
        console.log('saveGlobalUrlMap')
        await saveGlobalUrlMap({
          projectKey: router.currentRoute.query.id,
          uuid2url: assets.uuid2UrlConf,
        })
      }
      return new Promise((resolve, reject) => {
        EventBus.$once(Event.BG_REPLACE_CB, (flag) => {
          console.log('flag', flag)
          if (flag) {
            resolve()
          } else {
            reject()
          }
        })
        EventBus.$emit(Event.BG_REPLACE, fileObj)
      })
    },
  },
}
